import React from "react";
import { useNavigate } from "react-router-dom";
import "./InternshipList.css";

const internships = [
  {
    id: "java",
    title: "Java Developer",
    description: "Build scalable backend services using Java and Spring Boot.",
  },
  {
    id: "python",
    title: "Python Developer",
    description: "Work on backend systems, data processing, and automation tools.",
  },
  {
    id: "web",
    title: "Web Development",
    description: "Develop responsive web applications using React and JavaScript.",
  },
  {
    id: "database",
    title: "Database Developer",
    description: "Design and optimize database systems for analytics.",
  },
  {
    id: "ai",
    title: "AI/ML Developer",
    description: "Develop machine learning algorithms and recommendation systems.",
  },
  {
    id: "data",
    title: "Data Analytics",
    description: "Analyze data and generate insights for business decisions.",
  },
  {
    id: "datascience",
    title: "Data Science",
    description: "Apply statistical analysis and machine learning techniques.",
  },
  {
    id: "cloud",
    title: "Cloud Computing",
    description: "Deploy scalable applications on AWS, Azure and Google Cloud.",
  },
];

const InternshipList = () => {
  const navigate = useNavigate();

  return (
    <div className="iia-internship-wrapper">
      <div className="iia-header-section">
        <h1 className="iia-main-title">
          Launch Your Career with the{" "}
          <span className="iia-highlight-text">Perfect Internship</span>
        </h1>

        <p className="iia-sub-title">
          Discover exciting opportunities, gain real-world experience, and
          unlock your potential. Your dream internship awaits!
        </p>
      </div>

      <div className="iia-internship-grid">
        {internships.map((internship) => (
          <div
            className="iia-internship-card"
            key={internship.id}
          >
            <div className="iia-card-content">
              <h3 className="iia-card-title">
                {internship.title}
              </h3>

              <p className="iia-card-description">
                {internship.description}
              </p>
            </div>

            <button
              className="iia-details-btn"
              onClick={() =>
                navigate(`/InternshipDetails/${internship.id}`)
              }
            >
              View Details →
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InternshipList;